import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { NgbPaginationModule } from '@ng-bootstrap/ng-bootstrap';

import { SharedTableComponent } from './shared-table.component';
import { SwitcherModule } from '../switcher';
import { PipesModule } from '../../pipes';
import { UtilsModule } from '../utils';
import { FrontendIconsModule } from '@tablesready/frontend-icons';

@NgModule({
  declarations: [SharedTableComponent],
  imports: [
    CommonModule,
    NgbPaginationModule,
    PipesModule,
    SwitcherModule,
    UtilsModule,
    FrontendIconsModule,
    FormsModule,
  ],
  exports: [SharedTableComponent],
})
export class SharedTableModule {}
